import { PropsWithChildren } from 'react'
import styles from './Table.module.scss'
import clsx from 'clsx'

interface Props extends PropsWithChildren {
    className?: string
    ref?: React.RefObject<HTMLTableElement>
}

export const Table = ({ children, className, ref }: Props) => {
    return (
        <table className={clsx(styles.table, className)} ref={ref}>
            {children}
        </table>
    )
}
